import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const InstituteWidgetService = {
  getList: async () => {
    try {
      const response = await apiService.get("/universityintellwidgets");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/universityintellwidgets/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  create: async (data) => {
    const response = await apiService.post("/universityintellwidgets", data);
    return response.data;
  },

  getdetail: async (id) => {
    const response = await apiService.get(`/universityintellwidgets/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/universityintellwidgets/${id}`);
    return response.data;
  },
};

export default InstituteWidgetService;
